var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSourceAppsFlyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3095 5.04758L3.37792 8.98364C3.51915 9.2518 3.86726 9.46946 4.15482 9.46875L8.37439 9.45984C8.66244 9.45927 8.7813 9.24106 8.64019 8.97244L6.57156 5.03659C6.43045 4.76792 6.08241 4.55085 5.79457 4.55149L1.57508 4.56025C1.56857 4.56025 1.56227 4.56046 1.55576 4.56046C1.28203 4.57079 1.17137 4.78495 1.3095 5.04758Z",
    fill: "#75B82C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32593 9.62996L10.5785 11.9648C10.6637 12.1241 10.8721 12.2519 11.0437 12.25L13.5578 12.2234C13.7295 12.2217 13.7987 12.0911 13.7136 11.9317L12.4614 9.59706C12.376 9.43768 12.1673 9.31014 11.9962 9.31194L9.48204 9.33833C9.4791 9.33833 9.47633 9.33833 9.47339 9.33833C9.30813 9.34446 9.24206 9.47304 9.32593 9.62996Z",
    fill: "#75B82C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33946 0.762987L6.8257 3.98622C6.65389 4.20644 6.63112 4.60105 6.77459 4.86875L8.87619 8.78698C9.01944 9.05422 9.27498 9.09278 9.44651 8.87312L11.9605 5.64925C12.132 5.42946 12.155 5.03439 12.0113 4.76693L9.90998 0.848584C9.82666 0.693928 9.70621 0.615954 9.5861 0.620143C9.49892 0.623688 9.41173 0.670407 9.33946 0.762987Z",
    fill: "#3D90D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75162 9.66865L7.25339 11.5893C7.15083 11.7204 7.13761 11.9557 7.2229 12.1149L8.4752 14.4497C8.56088 14.609 8.71294 14.6319 8.81529 14.5008L10.3131 12.5804C10.4152 12.449 10.4289 12.2135 10.3437 12.0546L9.0913 9.71976C9.04199 9.62754 8.97 9.58102 8.89827 9.58337C8.84654 9.58517 8.79433 9.61319 8.75162 9.66865Z",
    fill: "#3D90D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSourceAppsFlyer);
export default __webpack_public_path__ + "static/media/data_source_apps_flyer.c11b785b68f1b3dbb39eae881aec4853.svg";
export { ForwardRef as ReactComponent };